export default class LeadModel {
  public leadId: string = null;
  public profileId: string = null;
  public firstName: string | null = null;
  public lastName: string | null = null;
  public fullName: string | null = null;
  public email: string | null = null;
  public gender: string | null = null;
  public country: string | null = null;
  public phoneCountryCode: string | null = null;
  public phoneNumber: string | null = null;
  public campaignId: string | null = null;
  public campaignName: string | null = null;
  public contentType: string | null = null;
  public contentId: string | null = null;
  public contentName: string | null = null;
  public customFields: Record<string, string> | null = null;
}
